import { CLASS_TYPE } from './enums';

export class JiraVersion {
    type = CLASS_TYPE.JIRA_VERSION;
    id: string;
    name: string;
}
